/**
 * Utility functions for handling API errors
 */

/**
 * Normalizes error keys by removing common suffixes
 * @param errorKey The raw error key from the API
 * @returns Normalized error key
 */
export function normalizeErrorKey(errorKey: string | undefined): string {
  if (!errorKey || typeof errorKey !== 'string') {
    return '';
  }

  // Remove common suffixes that might be added by the backend
  return errorKey
    .replace('WithIds', '')
    .replace('WithDetails', '')
    .trim();
}

/**
 * Checks if an error key indicates a blocked operation
 * @param errorKey The normalized error key
 * @param entityType The type of entity (e.g., 'indexes', 'chatbots')
 * @returns True if the error indicates a blocked operation
 */
export function isBlockedOperationError(errorKey: string, entityType: string): boolean {
  return errorKey.startsWith(`${entityType}.notifications.deleteBlocked`);
} 